import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "children"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
/**
 * Screenreader
 *
 * Provides text for screen readers that is visually hidden.
 * It is the logical opposite of the `aria-hidden` attribute.
 *
 * @see https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
 * @see https://a11yproject.com/posts/how-to-hide-content/
 * @see Docs     https://reacttraining.com/reach-ui/screenreader
 * @see Source   https://github.com/reach/reach-ui/tree/master/packages/screenreader
 */

var Screenreader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement("span", _extends({
    ref: ref,
    className: cx(styles.root, className)
  }, rest), children);
});
Screenreader.displayName = 'Screenreader';
Screenreader.identifier = Screenreader.displayName;
Screenreader.clonableProps = [];
Screenreader.propTypes = {
  /** Text for screen readers that is visually hidden. */
  children: PropTypes.node.isRequired,

  /** Extend classNames. */
  className: PropTypes.string
};
Screenreader.defaultProps = {};
export default Screenreader;